"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("./football/Facts");
const Facts_2 = require("./rugbyLeague/Facts");
const Facts_3 = require("./rugbyUnion/Facts");
exports.sportFactStatMap = {
    football: Facts_1.FootballFactStatMap,
    rugbyLeague: Facts_2.RugbyLeagueFactStatMap,
    rugbyUnion: Facts_3.RugbyUnionFactStatMap
};
//# sourceMappingURL=SportsFactStatMap.js.map